import InspectionsPageFilters from './InspectionsPageFilters-compose';

export default InspectionsPageFilters;
